import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EtiquetteService } from 'src/services/etiquette.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SupprimerEtiquetteModel } from 'src/models/pilotage/supprimerEtiquetteModel';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { ResultSupprimerEtiquettesModel } from 'src/models/pilotage/resultSupprimerEtiquettesModel';

@Component({
    selector: 'app-supprimer-etiquette-dialog',
    imports: [MatDialogModule, TranslateModule],
    templateUrl: './supprimer-etiquette-dialog.component.html',
    styleUrl: './supprimer-etiquette-dialog.component.scss'
})
export class SupprimerEtiquetteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SupprimerEtiquetteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { etiquetteId: number },
    private etiquetteService: EtiquetteService,
    private utilisateurService: UtilisateurService,
    private snackBar: MatSnackBar,
    private translateService: TranslateService
  ) { }

  confirmerSuppression(): void {
    const model: SupprimerEtiquetteModel = {
      etiquetteId: this.data.etiquetteId,
      entiteIdAccessibles: this.utilisateurService.contexteUtilisateur.entitesAccessibles.map(e => e.entiteId)
    }

    this.etiquetteService.supprimerEtiquettes(model).subscribe({
      next: (result: ResultSupprimerEtiquettesModel) => {
        if (result.etiquettesSucces.length > 0) {
          this.showSnackBar('TAGS_MANAGEMENT.DELETION_SUCCESSFUL');
          this.dialogRef.close(true);
        } else if (result.etiquettesDansAutreEntites.length > 0) {
          this.showSnackBar('TAGS_MANAGEMENT.USED_IN_OTHER_ENTITIES');
          this.dialogRef.close(false);
        } else {
          this.showSnackBar('TAGS_MANAGEMENT.NO_DELETION');
          this.dialogRef.close(false);
        }
      },
      error: (error) => {
        this.showSnackBar('TAGS_MANAGEMENT.DELETION_ERROR');
        this.dialogRef.close(false);
      }
    });
  }

  private showSnackBar(messageKey: string): void {
    this.translateService.get(messageKey).subscribe((message: string) => {
      this.snackBar.open(message, 'OK', { duration: 3000 });
    });
  }

  annuler(): void {
    this.dialogRef.close(false);
  }
}
